import React from "react";
import { Spin } from "antd";

/**
 * Sticky loader component for message pagination
 * Shows a smooth animated loader at the top when fetching more messages
 */
const PaginationLoader = ({ isLoading, loadingText = "Fetching more messages..." }) => {
  return (
    <div
      className={`sticky top-0 z-50 bg-white shadow-sm border-solid border-t-0 border-x-0 border-b border-grey-200 flex items-center justify-center gap-2 transition-all duration-300 ease-in-out overflow-hidden ${
        isLoading ? "py-3 px-4 opacity-100 max-h-20" : "py-0 px-4 opacity-0 max-h-0 border-0"
      }`}
    >
      <Spin size="small" />
      <span className="text-sm text-brand-600 whitespace-nowrap">{loadingText}</span>
    </div>
  );
};

export default PaginationLoader;
